'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ow = require('ow');

var _ow2 = _interopRequireDefault(_ow);

var _maybeInclude = require('maybe-include');

var _maybeInclude2 = _interopRequireDefault(_maybeInclude);

var _case = require('case');

var _case2 = _interopRequireDefault(_case);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isArray = Array.isArray;


var getStyleClassKey = function getStyleClassKey(descendentName) {
	return _case2.default.capital(descendentName, '_');
};

var findExtraClasses = function findExtraClasses(args) {
	var foundArray = args.find(function (classes) {
		return isArray(classes);
	});

	if (!foundArray) {
		return false;
	}

	return foundArray.filter(Boolean);
};

var findModifier = function findModifier(rootModifier, rootModifierCondition, descendentModifier, descendentModifierCondition) {
	if (rootModifier) {
		return rootModifierCondition && rootModifier;
	}

	if (descendentModifier) {
		return descendentModifierCondition && descendentModifier;
	}

	return false;
};

exports.default = function () {
	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	return function () {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		(0, _ow2.default)(args[0], _ow2.default.any(_ow2.default.string.nonEmpty, _ow2.default.object, _ow2.default.array, _ow2.default.undefined));
		(0, _ow2.default)(args[1], _ow2.default.any(_ow2.default.object, _ow2.default.array, _ow2.default.undefined));
		(0, _ow2.default)(args[2], _ow2.default.any(_ow2.default.array, _ow2.default.undefined));

		var prefix = options.prefix,
		    componentName = options.componentName,
		    props = options.props,
		    spread = options.spread;

		var isRoot = args.length === 0 || isArray(args[0]) || _typeof(args[0]) === 'object';

		var rootModifier = !isArray(args[0]) && _typeof(args[0]) === 'object' && Object.keys(args[0]).length && Object.keys(args[0])[0];
		var rootModifierCondition = rootModifier && args[0][rootModifier];

		var descendentModifier = _typeof(args[1]) === 'object' && !isArray(args[1]) && Object.keys(args[1]).length && Object.keys(args[1])[0];
		var descendentModifierCondition = descendentModifier && args[1][descendentModifier];

		var descendentName = !isRoot && !rootModifier && typeof args[0] === 'string' && args[0];
		var modifier = findModifier(rootModifier, rootModifierCondition, descendentModifier, descendentModifierCondition);

		var styleClassKey = prefix === 'CMS' && props && getStyleClassKey(descendentName || componentName);
		var styleClass = props && props.styleClasses && props.styleClasses[styleClassKey];
		var extraClasses = findExtraClasses(args) && findExtraClasses(args).join(' ') || '';

		var prefixString = (0, _maybeInclude2.default)(prefix, prefix + '-');
		var componentNameString = (0, _maybeInclude2.default)(componentName);
		var descendentNameString = (0, _maybeInclude2.default)(descendentName, '-' + descendentName);
		var modifierString = (0, _maybeInclude2.default)(modifier, '--' + modifier);

		var componentNameDescendentNameClass = '' + prefixString + componentNameString + descendentNameString;
		var componentNameDescendentNameModifierClass = (0, _maybeInclude2.default)(modifier, ' ' + prefixString + componentNameString + descendentNameString + modifierString);

		var propsClassString = (0, _maybeInclude2.default)(isRoot && props && props.class, ' ' + (props && props.class));
		var styleClassString = (0, _maybeInclude2.default)(styleClass, ' ' + styleClass);
		var extraClassesString = (0, _maybeInclude2.default)(extraClasses, ' ' + extraClasses);

		var finalClasses = '' + componentNameDescendentNameClass + componentNameDescendentNameModifierClass + propsClassString + styleClassString + extraClassesString;

		if (spread) {
			return {
				class: finalClasses,
				'data-style-attr': styleClassKey
			};
		}

		return finalClasses;
	};
};